import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import Deliver from '../../images/brand/svg/icons/Delivery_icon_constrained.svg';
import Pickup from '../../images/brand/svg/icons/Pick_UP_icon_constrained.svg';
import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import Text from '../ui-controls/Text';

const SIZE = 40;

type PickupDeliverButtonProps = {
  onPress: () => void;
  selected: boolean;
  disabled: boolean;
  text: string;
  icon: JSX.Element;
};
const PickupDeliverButton = ({
  onPress,
  selected,
  disabled,
  text,
  icon,
}: PickupDeliverButtonProps) => (
  <Pressable
    onPress={onPress}
    style={[
      styles.mainButton,
      selected ? styles.mainButtonSelected : styles.mainButtonUnselected,
    ]}
    disabled={disabled}>
    <Text
      style={[
        styles.mainButtonText,
        selected
          ? styles.mainButtonTextSelected
          : styles.mainButtonTextUnselected,
      ]}>
      {text}
    </Text>
    <View style={styles.mainButtonIconHolder}>{icon}</View>
  </Pressable>
);

const PickupDeliverComponent = observer(() => {
  const {shopSelectionStore, cartStore} = useStores();

  const handlePickupPressed = () => cartStore.setPickup(true);
  const handleDeliverPressed = () => cartStore.setDelivery(true);

  return (
    <View style={styles.row} testID="checkout-screen-pickup-delivery-selection">
      {!!shopSelectionStore.canPickup && (
        <PickupDeliverButton
          onPress={handlePickupPressed}
          selected={cartStore.isPickup}
          disabled={cartStore.submittingOrder || !shopSelectionStore.canPickup}
          text="Pick up"
          icon={
            <Pickup width={SIZE} height={SIZE} style={styles.mainButtonIcon} />
          }
        />
      )}
      {!!shopSelectionStore.canPickup && !!shopSelectionStore.canDeliver && (
        <View style={{marginHorizontal: 8}} />
      )}
      {!!shopSelectionStore.canDeliver && (
        <PickupDeliverButton
          onPress={handleDeliverPressed}
          selected={cartStore.isDelivery}
          disabled={cartStore.submittingOrder || !shopSelectionStore.canDeliver}
          text="Delivery"
          icon={
            <Deliver width={SIZE} height={SIZE} style={styles.mainButtonIcon} />
          }
        />
      )}
    </View>
  );
});

export default PickupDeliverComponent;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    paddingVertical: 8,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '50%',
  },
  mainButtonSelected: {
    backgroundColor: theme.colour.background.button.primary,
  },
  mainButtonUnselected: {
    backgroundColor: 'white',
    borderWidth: 0.5,
    borderColor: theme.colour.uiControls.primary,
  },
  mainButtonText: {
    marginRight: 8,
    width: '50%',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
  },
  mainButtonTextSelected: {
    color: 'white',
  },
  mainButtonTextUnselected: {
    color: theme.colour.text.heading.primary,
  },
  mainButtonIconHolder: {
    padding: 2,
    borderRadius: 4,
    backgroundColor: 'white',
  },
  mainButtonIcon: {
    backgroundColor: 'white',
  },
});
